import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "966ba816-0dc5-4d61-bc73-212f3ed0e20b", // Azure App Client ID
    authority: "https://login.microsoftonline.com/718b6c79-5aed-401e-88d3-058a133c531d",
    redirectUri: "https://adminpanel.thinkcloudly.co/redirect/azure/",
    postLogoutRedirectUri: "https://adminpanel.thinkcloudly.co/login/",

    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// ✅ Centralized MSAL Instance
export const msalInstance = new PublicClientApplication(msalConfig);

// ✅ Fix: Add `User.Read` scope
export const loginRequest = {
  scopes: ["User.Read"],
};
